import { Spin } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import {
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import { antIcon, convertSecsToTime } from "../../Helpers/helpers";
import { colors } from "../../Utils/constants";
import moment from "moment";

const LineGraph = ({ data = [] }) => {
  const { stats = null, line, machine } = useSelector((state) => state.kpis);
  const {
    pageLoaders,
    componentLoaders: { chart = false },
  } = useSelector((state) => state?.utils.loaders);

  const productChange = data.find((item) => item.productChanged);
  const batchNumber = data.find((item) => item.batchNumber);

  const toolTipStyles = {
    backgroundColor: "white",
    padding: "10px 20px",
    borderRadius: "10px",
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    fontSize: "16px",
  };


  const startTime = data[0].time; // Assuming the data is sorted by time
  const midTimeIndex = Math.floor(data.length / 2);
  const midTime = data[midTimeIndex].time;
  const endTime = data[data.length - 11].time;

  const chartkeys = [
    "targetOEE",
    "oee",
    // 'disconnectTime',
    // 'availability',
    // 'lineSpeed',
    // 'quality',
    // 'totalRejections',
    // 'goodOutput',
    // 'speedInMinute'
  ];

  const lineStatus = {
    up: <div className="line-up">up</div>,
    down: <div className="line-down">down</div>,
    disconnect: <div className="line-disconnect">disconnect</div>,
    "shift ended": <div className="line-up">shift ended</div>,
  };

  const CustomTooltip = ({ active, payload, label }) => {
    let keyNames = {
      targetOEE: "Target OEE",
      oee: "OEE",
      disconnectTime: "Disconnect Time",
      // availability: "Availability"
      // lineSpeed: "Linespeed",
      // quality: "Quality",
      // totalRejections: "Total Rejections",
      // goodOutput: "Good Ouput",
      // speedInMinute: "Production Speed ( Minutes )"
    };

    if (active && payload && payload.length) {
      return (
        <div style={toolTipStyles}>
          <p className="intro">Time: {moment(label).format("hh:mm:ss a")}</p>
          {/* <p className="intro">Date: {moment(label).format("MMMM Do YYYY")}</p> */}
          {payload?.map((data, i) => {
            const { payload, id } = data;
            return (
              <div key={id}>
                <h5
                  className="tooltip-keyName"
                  style={{
                    color:
                      data.dataKey === "oee" &&
                      payload?.lineStatus == "down" &&
                      !isNaN(payload?.down)
                        ? "#EB5757 "
                        : !isNaN(payload?.disconnect)
                        ? "#ed9226"
                        : colors[i],
                  }}
                >
                  {keyNames[data?.dataKey]}:{" "}
                  {Math.round(data?.value).toFixed(2)}
                </h5>
                {data.dataKey === "oee" && (
                  <div>
                    <h5
                      className=""
                      style={{
                        color:
                          data.dataKey === "oee" &&
                          payload?.lineStatus == "down" &&
                          !isNaN(payload?.down)
                            ? "#EB5757"
                            : !isNaN(payload?.disconnect)
                            ? "#ed9226"
                            : data.dataKey === "oee" && colors[i],
                      }}
                    >
                      {" "}
                      {payload?.planDowntime ? (
                        <div>
                          {payload?.batchNumber ? (
                            <div className="line-batch">
                              Batch Changeover: {payload?.batchNumber}
                            </div>
                          ) : (
                            <div className="line-planned">Planned Downtime</div>
                          )}
                        </div>
                      ) : payload?.batchNumber ? (
                        <div className="line-batch">
                          Batch Changeover: {payload?.batchNumber}
                        </div>
                      ) : payload?.productChanged ? (
                        <div className="line-productChange">
                          Product Changed
                        </div>
                      ) : (
                        lineStatus[payload?.lineStatus]
                      )}
                    </h5>
                    <h5
                      className="tooltip-keyName"
                      style={{
                        color:
                          data.dataKey === "oee" &&
                          payload?.lineStatus == "down" &&
                          !isNaN(payload?.down)
                            ? "#EB5757"
                            : !isNaN(payload?.disconnect)
                            ? "#ed9226"
                            : data.dataKey === "oee" && colors[i],
                      }}
                    >
                      {payload?.planDowntime ? "Planned Downtime" : "Downtime"}:{" "}
                      {convertSecsToTime(payload?.downtime)}
                    </h5>
                    <h5
                      className="tooltip-keyName"
                      style={{
                        color:
                          data.dataKey === "oee" &&
                          payload?.lineStatus == "down" &&
                          !isNaN(payload?.down)
                            ? "#EB5757"
                            : !isNaN(payload?.disconnect)
                            ? "#ed9226"
                            : data.dataKey === "oee" && colors[i],
                      }}
                    >
                      A.P.Q: {payload?.a} | {payload?.p} | {payload?.q}
                    </h5>
                    <h5
                      className="tooltip-keyName"
                      style={{
                        color:
                          data.dataKey === "oee" &&
                          payload?.lineStatus == "down" &&
                          !isNaN(payload?.down)
                            ? "#EB5757"
                            : !isNaN(payload?.disconnect)
                            ? "#ed9226"
                            : data.dataKey === "oee" && colors[i],
                      }}
                    >
                      Good Count: {payload?.gc}
                    </h5>
                    <h5
                      className="tooltip-keyName"
                      style={{
                        color:
                          data.dataKey === "oee" &&
                          payload?.lineStatus == "down" &&
                          !isNaN(payload?.down)
                            ? "#EB5757"
                            : !isNaN(payload?.disconnect)
                            ? "#ed9226"
                            : data.dataKey === "oee" && colors[i],
                      }}
                    >
                      Rejections: {payload?.totalRejections}
                    </h5>
                    <h5
                      className="tooltip-keyName"
                      style={{
                        color:
                          data.dataKey === "oee" &&
                          payload?.lineStatus == "down" &&
                          !isNaN(payload?.down)
                            ? "#EB5757"
                            : !isNaN(payload?.disconnect)
                            ? "#ed9226"
                            : data.dataKey === "oee" && colors[i],
                      }}
                    >
                      Line Speed: {payload?.speedInMinute}
                    </h5>
                    <h5
                      className="tooltip-keyName"
                      style={{
                        color:
                          data.dataKey === "oee" &&
                          payload?.lineStatus == "down" &&
                          !isNaN(payload?.down)
                            ? "#EB5757"
                            : !isNaN(payload?.disconnect)
                            ? "#ed9226"
                            : data.dataKey === "oee" && colors[i],
                      }}
                    >
                      Disconnect Time:{" "}
                      {convertSecsToTime(payload?.disconnectTime)}
                    </h5>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
    }
  };

  const CustomXAxisTick = (props) => {
    const { x, y, payload } = props;
    const formattedTime = moment(payload.value).format("hh:mm a");

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
          {formattedTime}
        </text>
      </g>
    );
  };

  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer>
        <ComposedChart
          width={500}
          height={400}
          data={data}
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          <defs>
            {/* <linearGradient id="splitColor-1" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="20%" stopColor="#1E6EFE" stopOpacity={0.2} />
                            <stop offset="80%" stopColor="#E9F0FB" stopOpacity={0.9} />
                        </linearGradient> */}
            <linearGradient id="splitColor-2" x1="0" y1="0" x2="100%" y2="0">
              {data?.map((item, i) => {
                let target = data?.length;
                let total = 100;
                let ratio = total / target;
                const gradientColor = item?.planDowntime
                  ? "#e9f9ee"
                  : item?.lineStatus === "down" && !isNaN(item?.down)
                  ? "#D8CBE1"
                  : !isNaN(item?.disconnect)
                  ? "#facd98"
                  : "#CDDDFC";
                return (
                  <stop
                    key={i}
                    offset={`${(ratio * (i + 1)).toFixed(0)}%`}
                    stopColor={gradientColor}
                  />
                );
              })}
            </linearGradient>
            <linearGradient id="splitColor-3" x1="0" y1="0" x2="100%" y2="0">
              {data?.map((item, i) => {
                let target = data?.length;
                let total = 100;
                let ratio = total / target;
                const gradientColor = item?.planDowntime
                  ? "#1EA849"
                  : item?.lineStatus === "down" && !isNaN(item?.down)
                  ? "#EB5757"
                  : !isNaN(item?.disconnect)
                  ? "#ed9226"
                  : "#1E6EFE";
                return (
                  <stop
                    key={i}
                    offset={`${(ratio * (i + 1)).toFixed(0)}%`}
                    stopColor={gradientColor}
                  />
                );
              })}
            </linearGradient>
          </defs>

          <XAxis
            dataKey="time"
            type="category"
            interval={0}
            tick={<CustomXAxisTick />}
            ticks={[startTime, endTime]}
          />
          <YAxis dataKey={"maxOEE"} />
          <Line
            strokeDasharray={`5 5`}
            // type="monotone"
            dataKey={"targetOEE"}
            opacity={1}
            strokeWidth={3}
            stroke={colors[0]}
            activeDot={{ r: 3 }}
            dot={false}
          />
          <Area
            dataKey="oee"
            stroke={"url(#splitColor-3)"}
            strokeWidth={3}
            // fill={"#1E6EFE"}
            fillOpacity={0.6}
            fill="url(#splitColor-2)"
            type="linear"
          />
          {productChange && (
            <ReferenceLine
              x={productChange.time}
              stroke="#9D00FF"
              strokeWidth={2.5}
              isFront
            />
          )}

          {batchNumber && (
            <ReferenceLine
              x={batchNumber.time}
              stroke="#39FF14"
              strokeWidth={2.5}
              isFront
            />
          )}
          <Tooltip content={CustomTooltip} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineGraph;
